export const code = `import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./index.css";

const mockData = [
  {
    ActivityId: 1858268506542091,
    ActivityInfo: {
      SdkToken: "lITPIp",
    },
  },
  {
    ActivityId: 1858337977046043,
    ActivityInfo: {
      SdkToken: "BeXQdV",
    },
  },
  {
    ActivityId: 1858337974175033,
    ActivityInfo: {
      SdkToken: "KmVJTx",
    },
  },
];

function Swiper() {
  const currentIndexRef = useRef(0);
  const sdkMapRef = useRef(new Map());
  const sdkPlayerMapRef = useRef(new Map());

  useEffect(() => {
    if (mockData.length === 0) {
      return;
    }

    new window.Swiper(".swiper-container", {
      direction: "vertical",
      loop: true,
      edgeSwipeDetection: true,
      on: {
        slideChange: function () {
          const index = this.realIndex;
          if (sdkMapRef.current.has(index) && sdkPlayerMapRef.current.has(index)) {
            sdkPlayerMapRef.current.get(index)?.play();
          } else {
            const sdk = createSDK(index);
            sdkMapRef.current.set(index, sdk);
            sdk.once("player.playing", player => {
              sdkPlayerMapRef.current.set(index, sdk.getPlayerInstance());
            });
            sdk.once("player.play", () => {
              sdkPlayerMapRef.current.set(index, sdk.getPlayerInstance());
            });
          }
          if (sdkPlayerMapRef.current.has(currentIndexRef.current)) {
            sdkPlayerMapRef.current.get(currentIndexRef.current)?.pause();
          }
          currentIndexRef.current = index;
        },
        touchStart: function (swiper, e) {
          const touchY = e.clientY;
          const screenBottom = window.innerHeight;
          console.log(screenBottom - touchY, ">>>>>");
          if (screenBottom - touchY < 30) {
            swiper.allowTouchMove = false; // 禁用滑动
            console.log("系统手势区域生效");
          }
        },
        touchEnd(swiper) {
          swiper.allowTouchMove = true; // 恢复滑动
        },
      },
    });

    function genSDKConfig(index) {
      const { ActivityId, ActivityInfo } = mockData[index];
      const { SdkToken } = ActivityInfo;
      const config = {
        activityId: Number(ActivityId),
        token: SdkToken,
        service: "liveDemo",
        mode: 1,
        modules: [
          {
            id: \`app-\${index}\`,
            mode: "mobile-portrait",
          },
        ],
        options: {
          saveUserInfo: true,
          // autoPlay: 3,
          softSolution: true, // Set whether to forcefully enable or disable player soft decoding of live video on the mobile terminal. Enabling soft decryption can solve the problem of players being hijacked in some browsers or apps on the mobile side. Configuration is not recommended by default.
          playerConf: {
            loop: true,
          },
        },
      };
      return config;
    }

    function createSDK(index) {
      const config = genSDKConfig(index);
      const sdk = new window.ByteLiveWebSDK(config);
      sdk.on("error", console.log);
      return sdk;
    }
  }, [mockData]);

  return (
    <div className="container">
      {/* Temporarily solve it by focusing the player */}
      <div
        className="swiper-container"
        onClick={() => {
          window.commonPlayer?.focus();
        }}
      >
        <div className="swiper-wrapper">
          {mockData.map((item, key) => (
            <div className="swiper-slide" key={key}>
              <div id={\`app-\${key}\`} className="sdk-root" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Swiper;

ReactDOM.render(<Swiper />, document.getElementById("root"));
`;
